import React from "react";

import Button from 'react-bootstrap/Button';



export const makeButton = (download, onClick, disabled) => {
    const classes = `btn-success btn btn-multi-line ${disabled ? 'disabled' : ''}`;
    const label = download ? 'Abrufen' : 'Anzeigen';

    if (disabled)
        onClick = undefined;

    return download ? (
            <a
                href = {onClick}
                className = {classes}
                role = {'button'}>
                {label}
            </a>
        ) : (
        <Button
            className = {classes}
            disabled = {disabled}
            onClick = {onClick}>
            {label}
        </Button>
    );
};
